module.exports = __webpack_public_path__ + "img/stayPayReturn.66777a59.svg";